<template>
  <div class="page__wrapper" @scroll="onScroll()">
    <FCInvestment :h2="this.h2" :h3="this.h3" deposit="true">
      <template v-slot:copy>
        <p
          class="smaller"
        >Since the 2017 season, season tickets in The Bailey have been sold out. Doubling the section in 2021 will allow more fans, more growth, and more potential.</p>
        <p class="margin-top smaller">
          Additionally FC Cincinnati has announced that season ticket pricing in The Bailey will remain flat in 2021, with
          <span
            class="orange"
          >season tickets costing less than $20 per match.</span>
        </p>
        <p
          class="margin-top smaller"
        >Interested in season tickets in The Bailey? Place your $50 non-refundable deposit today by clicking on the link below.</p>
        <div class="margin-top">
          <div>
            <div class="investment-element margin-bottom">
              <div>
                <p class="uppercase">Section 106 - 110</p>
                <div class="pad">
                  <div class="price-per-year">{{seats * price0 | toCurrency}}</div>
                  <p class="small">Per season ticket</p>
                </div>
              </div>
              <div class="map">
                <img
                  src="~@/assets/maps/reserve-bailey.png"
                  alt
                  data-aos="zoom-in-up"
                  data-aos-duration="250"
                  data-aos-easing="ease-out-cubic"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="text-center margin-top">
          <a
            href="https://deposits.fccincinnati.com/events/2021%20reserved%20seat%20deposit/2020-12-31_19.30/fc%20cincinnati%20deposits?back=2&area=7a133315-3411-453c-ab26-41e4142dfcab&type=ga"
          >
            <FCButtonCTA text="Make Your Deposit" />
          </a>
        </div>
      </template>
    </FCInvestment>
  </div>
</template>

<script>
/*
<a
            target="_blank"
            href="https://deposits.fccincinnati.com/events/2021 club deposit/2020-12-31_19.30/fc cincinnati deposits"
            @click="$gtag.event('begin_checkout', {'event_label': 'Pitch View Club'})"
          >
            <FCButtonCTA text="Claim your place" />
          </a>
          */
import FCInvestment from "@/components/patterns/FCInvestment";
import FCButtonCTA from "@/components/patterns/FCButtonCTA";
export default {
  components: {
    FCInvestment,
    FCButtonCTA,
  },
  filters: {
    toCurrency: function (value) {
      if (typeof value !== "number") {
        return value;
      }
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
      return formatter.format(value);
    },
  },
  mounted() {
    const ref = this.$store.state.menu.bailey.ref;
    const index = this.$store.state.menu.menuItems
      .map((e) => e.ref)
      .indexOf(ref);
    this.$store.state.menu.activeSection = index;
    this.$store.state.menu.currentSectionTitle = this.$store.state.menu.bailey.title;
    this.$store.state.menu.currentSectionNavigation = this.$store.state.menu.bailey.nav;
    this.onScroll();
  },
  data() {
    return {
      h2: "The Bailey",
      h3: "Claim Yours",
      seats: 1,
      price0: 325,
    };
  },
  methods: {
    changeSeats(_modifier) {
      let _currentValue = this.seats;
      this.seats = Math.max(1, _currentValue + _modifier);
    },
  },
};
</script>

<style lang="scss" scoped>
.page__wrapper {
  background-image: url("~@/assets/backgrounds/bg-thebailey.jpg");
  background-size: cover;
  background-position: center;
}
</style>